export const formatCLP = (value) => {
  if (!value) return "";
  const number = parseFloat(value); // mantiene los decimales si vienen
  if (isNaN(number)) return "";
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
    minimumFractionDigits: 0,
  }).format(number);
};


